import React, { useEffect, useState } from 'react'
import RishikeshBanner from '../Rishikesh/RishikeshBanner';
import RishikeshHead from '../Rishikesh/RishikeshHead';
import RishikeshAbout from '../Rishikesh/RishikeshAbout';
import RishTestimonial from '../Rishikesh/RishTestimonial';
import GoaDining from './GoaDining';
import GoaPlace from './GoaPlace';
import GoaRoom from './GoaRoom';
import GoaVideo from './GoaVideo';
import GoaNearby from './GoaNearby';
import GoaGallery from './GoaGallery';
import OfferPopup from '../../component/OfferPopup';

export default function Goa() {

const [showPopup, setShowPopup] = useState(false);

useEffect(() => {
  setShowPopup(true);
}, []);

const handleClose = () => {
  setShowPopup(false);
};


  const bannerData = {
    images: [
      { img: "/image/goa-banner-1.webp" },
      { img: "/image/goa-banner-2.webp" },
      { img: "/image/goa-banner-3.webp" },
      { img: "/image/goa-banner-4.webp" },
    ],
    buttonLink: "https://www.swiftbook.io/inst/#home?propertyId=963MjgsolW0h7uc1ZijJxO0lkzsqHF2oUxvyvlueoPaIL0TFw8FUwK5Ng==&JDRN=Y"
  };


  const quoteHead = {
    title: "De Coração Goa",
    desc: "When was the last time you let the clock stop? Deep within. Peaceful. Calm. At De Coração Goa, we believe the best moments happen between the golden sunsets of the Arabian Sea and the gentle rhythm of the tides.",
  };


  const aboutData = {
    title: "",
    heading: "Step away from the rush and into a world where the sea meets golden sands just a short stroll from your door. Immerse in the vibrant energy of Calangute’s coastal cafés or go for a quiet walk under swaying palms for rediscovering balance.",
    desc: "Here, the tropical breeze carries a gentle reminder that you are exactly where you need to be. Immerse yourself in a rhythm that soon feels naturally your own, where the world meets sunlit sands, a short stroll takes you through vibrant cafés, and the coastal energy invites a quiet walk along the shore.",
    Linktext: "Book Your Stay",
    target: "_blank",
    Link: "https://www.swiftbook.io/inst/#home?propertyId=963MjgsolW0h7uc1ZijJxO0lkzsqHF2oUxvyvlueoPaIL0TFw8FUwK5Ng==&JDRN=Ynpm",
    Image1: "/image/goa-about-1.webp",
    Image2: "/image/goa-about-2.webp",
  }

const offerPopupData = {
  leftImage: "/image/offer-left-image.webp",
  mobileImage: "/image/offer-left-mobile-image-3.webp",
  label: "brand website",
  title: "exclusive",
  highlight: "offer",
  description:
    "Enjoy exclusive benefits when you book directly through our Brand Website.",

benefits: [
    {
      icon: "/image/offerpopup-icon-1.webp",
      text1: "15% OFF",
      text2: "on Food & Beverages",
    },
    {
      icon: "/image/offerpopup-icon-2.webp",
      text1: "Beer Bucket",
      text2: "@  \u20B9 599",
      text2Class: "price-highlight",
    },
    {
      icon: "/image/offerpopup-icon-3.webp",
      text1: "15% OFF",
      text2: "on Laundry",
    },
    {
      icon: "/image/offerpopup-icon-4.webp",
      text1: "Complimentary Room Upgrade",
      text2: "To The Next Category",
    },
    {
      icon: "/image/offerpopup-icon-5.webp",
      text1: "Subject to Avaliblity",
      text2: "Early Check-In & Late Check Out",
    },
    {
      icon: "/image/offerpopup-icon-6.webp",
      text1: "2 Pints of Beer",
      text2: "on arrival",
    },   
  ],
};


const testimonialData = [
    {
        text: "Resort De Coracao truly lives up to its name, a place that feels like it was designed from the heart. The serene atmosphere, warm hospitality, and thoughtful details made our stay unforgettable, creating moments of comfort and relaxation we will always cherish.",
        image: "/image/testiclient-1.webp",
        name: "Arpit Sharma",
        designation: "Happy Customer",
    },
    {
        text: "Resort De Coracao perfectly reflects its meaning, offering a heartfelt experience where every detail is crafted with care. From the peaceful surroundings to the genuine hospitality and beautifully designed spaces, every moment felt warm, welcoming, and truly memorable.",
        image: "/image/testiclient-2.webp",
        name: "Deepti Kapoor",
        designation: "Happy Customer",
    },
    {
        text: "All the hotel staff are extremely helpful and polite. The rooms are very clean and well-maintained. The food was delicious and the service was excellent. This is a wonderful property. Special thanks to the housekeeping team, and the front office team for their kindness and warm hospitality.",
        image: "/image/testiclient-3.webp",
        name: "Nishant Kumar",
        designation: "Happy Customer",
    },
    {
        text: "The location of hotel is excellent. The rooms are good and well maintained by daily housekeeping. The executive rooms have balcony which is great especially when you want to feel the evening breeze. Last but not the least the staff is very friendly and helpful.",
        image: "/image/testiclient-4.webp",
        name: "Vrushali Patil",
        designation: "Happy Customer",
    },
    {
        text: "I had a lovely stay at Resort de Coracao. The staff went above and beyond to ensure we had a great stay. They were all so friendly and attentive. The food was delicious we regularly ate dinner at the hotel restaurant. The housekeeping was very good, room always had fresh towels. I would definitely recommend staying here.",
        image: "/image/testiclient-5.webp",
        name: "Abbey Alliston",
        designation: "Happy Customer",
    },
    {
        text: "Me and my family had an amazing experience at this hotel. The staff was extremely humble, courteous, and always ready to help, which made our stay very comfortable. The breakfast was good, tasty, and had nice variety. Overall, it was a pleasant and memorable stay, and we would definitely recommend this hotel to others.",
        image: "/image/ankur-goyal.webp",
        name: "Ankur Goyal",
        designation: "Happy Customer",
    },
    {
        text: "The hotel exceeded my expectations. The check-in process was smooth, the room was spacious and clean, and the staff was extremely helpful. Food quality was good and the overall ambience was pleasant. Would love to stay here again. Wonderful experience overall. The staffs deserve special appreciation for their courteous behaviour and prompt service.",
        image: "/image/testiclient-6.webp",
        name: "Anmol Tawade",
        designation: "Happy Customer",
    },
];

const goaGalleryImages = [
    { src: "/image/goa-gallery-1.webp", alt: "Goa gallery 1" },
    { src: "/image/goa-gallery-2.webp", alt: "Goa gallery 2" },
    { src: "/image/goa-gallery-3.webp", alt: "Goa gallery 3" },
    { src: "/image/goa-gallery-4.webp", alt: "Goa gallery 4" },
    { src: "/image/goa-gallery-5.webp", alt: "Goa gallery 5" },
    { src: "/image/goa-gallery-6.webp", alt: "Goa gallery 6" },
    { src: "/image/goa-gallery-7.webp", alt: "Goa gallery 7" },
    { src: "/image/goa-gallery-8.webp", alt: "Goa gallery 8" },
];



  return (
    <>
      <RishikeshBanner bannerImages={bannerData.images} buttonLink={bannerData.buttonLink} />
      <RishikeshHead quoteHead={quoteHead} />
      <RishikeshAbout aboutData={aboutData} />
      <GoaRoom />
      <GoaVideo />
      <GoaPlace />
      <GoaDining />
      {/* <GoaGallery /> */}
      <GoaGallery images={goaGalleryImages} heading="Discover the unforgettable moments our guests have captured and shared from their extraordinary stays with us."/>
      <RishTestimonial testimonialData={testimonialData}/>
      <GoaNearby />

      <OfferPopup show={showPopup} onHide={handleClose} data={offerPopupData}/>
      
    </>
  )
}
